module.exports = __webpack_public_path__ + "static/media/order.3750abce.svg";